import axios from '@/plugins/axios'

export default {
  getBannerOneCommerces(){
    return axios({
      url: `/onecommerces/promotion/check-store`,
      method: 'get'
    })
  },
  checkOnecommercesCode(params) {
    return axios({
      url: `/onecommerces/promotion/check-store`,
      method: 'get',
      params
    })
  }
}